let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jDiO5")).then(() => parcelRequire('ckIl0'));